import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { treehouseCardMotion } from './motion';
import { treehouseChromeTone } from './palette';

export const treehouseTheme: FlowThemeDefinition = {
  id: 'treehouse',
  label: 'Treehouse',
  description: 'A woodland retreat goes up in a great oak, one part per answer, until dusk falls and its windows, lanterns and rope bridge glow.',
  category: 'daylight',
  chromeTone: treehouseChromeTone,
  swatch: 'linear-gradient(165deg, #2C5A36 0%, #6A8E3A 30%, #FFE2AE 52%, #C99260 70%, #74523A 100%)',
  cardGlass: 'dense',
  cardMotion: treehouseCardMotion,
  burstSize: 300,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createTreehouseScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
